<div class="container container-main">
  <app-general-header [title]="'Download CSV'" />
  <div class="card border-0 p-3">
    <h2 class="my-4">Your Requested File</h2>
    <a [href]="fileUrl" target="_blank" download>{{ fileName }}</a>
  </div>
</div>
